import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { ItemsDetailsService } from '../../services/items-details/items-details.service';
import { PlannedAtLoadingRow } from '../../models/planned-at-loading-item';

@Component({
  selector: 'app-planned-at-loading-dialog',
  templateUrl: './planned-at-loading-dialog.component.html',
  styleUrls: ['./planned-at-loading-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class PlannedAtLoadingDialogComponent implements OnInit, OnChanges {
  @Input() routeDetails: any;
  wrapUnwrap: boolean = false;
  items: PlannedAtLoadingRow[] = [];
  isLoading = false;

  readonly columns = [
    { id: 'route_name', label: 'Route Name' },
    { id: 'bl_name', label: 'BLOM Location' },
    { id: 'receiver_name', label: 'Receiver Name' },
    { id: 'address', label: 'Address' },
    { id: 'barcode', label: 'Barcode' },
    { id: 'time_window', label: 'Time Window' },
    { id: 'item_state', label: 'Item State' },
    { id: 'product_code', label: 'Product Code' },
    { id: 'asc', label: 'ASC' }
  ];

  constructor(private readonly itemsDetailsService: ItemsDetailsService) {}

  ngOnInit(): void {
    this.loadItemsData();
  }

  // Reloads table data when route details input changes.
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['routeDetails'] && !changes['routeDetails'].firstChange) {
      this.loadItemsData();
    }
  }

  // Fetches planned-at-loading items for the selected route.
  private loadItemsData(): void {
    if (!this.routeDetails?.route_id) {
      this.items = [];
      return;
    }

    this.isLoading = true;
    const routeId = this.routeDetails.route_id;

    this.itemsDetailsService.getPlannedAtLoadingRows(routeId).subscribe({
      next: (rows) => {
        this.items = rows;
        this.isLoading = false;
      },
      error: () => {
        this.items = [];
        this.isLoading = false;
      }
    });
  }

  // Opens route details in a new tab for the selected row.
  openRouteInfo(row: PlannedAtLoadingRow): void {
    const routeId = row?.['route_id'];

    if (!routeId) {
      return;
    }

    sessionStorage.setItem('route_Id', routeId);
    window.open('#/routeinfo', '_blank');
  }

  // Opens barcode lookup in a new tab for the selected row.
  barcodeClicked(row: PlannedAtLoadingRow): void {
    const barcode = row?.['barcode'];
    if (!barcode) {
      return;
    }
    window.open('#/lookup?barcode=' + encodeURIComponent(barcode), '_blank');
  }

}
